import { render } from "./ModalRoom.vue?vue&type=template&id=2098fa04"
import script from "./ModalRoom.vue?vue&type=script&lang=js"
export * from "./ModalRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__